import React from "react"

class AutomaticPriceRuleAppliedToDataType extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    var applied_to = null
    if(typeof this.props.data === 'object') {
      applied_to = `${I18n.t(this.props.data.occupancy_comparator)} ${this.formatPercentage(this.props.data.occupancy_percentage)} ${I18n.t('occupancy')}`
    } else {
      applied_to = I18n.t(this.props.data)
    }
    return(
      <div>{applied_to}</div>
    )
  }

  formatPercentage(num) {
    return parseFloat((num * 100).toFixed(2)) + "%"
  }

}

export default AutomaticPriceRuleAppliedToDataType